import {IonItem, IonList} from "@ionic/react";
import React from "react";
import {FormItem, IFormItems, IFormProps} from "../../component/form/model/FormModel";
import BasicForm from "../../component/form/BasicForm";
import ApiResponseVO from "../../../ts/manager/api/ApiResonseVO";
import {getManager} from "../../../ts/manager/Manager";
import {IAnyObject} from "../../../ts/common/SimpleInterface";
import InputFIE from "../../component/form/form-item-element/InputFIE";
import AppButton from "../../element/button/AppButton";
import PasswordInputFIE from "../../component/form/form-item-element/PasswordInputFIE";

interface IRegisterProps extends IFormProps
{
    includeAccountButtons?: boolean;
}

export default class AccountRegisterForm extends BasicForm
{
    props: IRegisterProps;

    debugEmail = "";
    debugPassword = "";
    debugConfirmPassword = "";
    debugFirstName = "";
    debugLastName = "";

    constructor(props: IRegisterProps)
    {
        super(props);

        this.props = props;
    }

    applyDebugValues()
    {
        super.applyDebugValues();
    }

    getLocalError(formItem: FormItem): string|null
    {
        let localError = super.getLocalError(formItem);
        if (localError)
        {
            return localError;
        }
        const confirmPassword = this.stringItem('confirm_password').getCastValue();
        const password = this.stringItem('password').getCastValue();
        if (formItem.itemID === "password")
        {
            if(!confirmPassword){
                return "Please confirm your password";
            }
        } else if (formItem.itemID === "confirm_password")
        {
            if (confirmPassword)
            {
                if (confirmPassword !== password)
                {
                    return "Passwords do not match";
                }
            }
        }
        return null;
    }


    async handleSubmitItems(formItemIDs: string[]|null): Promise<ApiResponseVO>
    {
        const params = this.collectParams(formItemIDs);
        const responseVO = await getManager().api.fetchData("/account/register", "POST", params);
        if ((responseVO.apiError?.lineErrors.username?.errors ?? []).length && (responseVO.apiError?.lineErrors.email?.errors ?? []).length)
        {
            delete responseVO.apiError?.lineErrors.username;
        }
        return responseVO;
    }


    async getAdditionalData(responseVO: ApiResponseVO): Promise<void>
    {
        let error: string | null = getManager().user.login(responseVO.data.user, false, responseVO.data.token, true);
        if (error)
        {
            return Promise.reject(error);
        }
        const accessTokens = getManager().user.unregisteredOrganisationAccess;
        if (!Object.keys(accessTokens).length)
        {
            getManager().user.handleUserLogInOut();
            return;
        }
        const params: IAnyObject = {}
        params.unregistered_access_tokens = accessTokens;
        return await getManager().api.fetchData("/organisation/set_unregistered_access_to_registered", "POST", params, true).then(responseVO =>
        {
            if (responseVO.apiError)
            {
                getManager().user.handleUserLogInOut();
                return Promise.reject(responseVO.apiError);
            }
            getManager().user.removeAllUnregisteredOrganisationAccess();
            getManager().user.handleUserLogInOut();
        })
    }

    renderComponent()
    {

        return <>

            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <form
                            onSubmit={this.handleFormSubmit}
                            className={"custom-form "+(this.isDisabled() ? "content-disabled" : "")}
                        >

                            {this.startFormAlerts()}
                            {this.requiredFieldsMessage()}
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "email",
                                            name: "Email Address",
                                            value: this.debugEmail,
                                            required: true,
                                            errorMessages: {
                                                required: "Email address is required"
                                            }
                                        }}
                                        elementProps={{
                                            type: "email"
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "password",
                                            name: "Password",
                                            value: this.debugPassword,
                                            required: true,
                                            errorMessages: {
                                                required: "Password is required"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <PasswordInputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "confirm_password",
                                            name: "Confirm Password",
                                            value: this.debugConfirmPassword,
                                            doNotSubmit: true
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "first_name",
                                            name: "First Name",
                                            value: this.debugFirstName,
                                            required: true,
                                            errorMessages: {
                                                required: "First name is required"
                                            }
                                        }}
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <InputFIE
                                        form={this}
                                        formItemProps={{
                                            pointer: "last_name",
                                            name: "Last Name",
                                            value: this.debugLastName,
                                        }}
                                    />
                                </div>
                            </div>

                            {this.endFormAlerts()}
                            <div className="clearfix">
                                <div className="form-group float-start mt-4">
                                    <AppButton
                                        type="submit"
                                        loading={this.loading}
                                        className="btn btn-block btn-primary"
                                        disabled={this.isSubmitDisabled()}
                                    >
                                        Register
                                    </AppButton>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>

        </>;
    }
}
